import HeroSection from "@/components/HeroSection";
import TrustStrip from "@/components/TrustStrip";
import ServicesSection from "@/components/ServicesSection";
import HowItWorks from "@/components/HowItWorks";
import ReviewsSection from "@/components/ReviewsSection";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import StickyCallButton from "@/components/StickyCallButton";
import MovingSimpleSection from "@/components/MovingSimpleSection";
import ComparisonSection from "@/components/ComparisonSection";
import SocialProofStats from "@/components/SocialProofStats";
import FinalCta from "@/components/FinalCta";

const Index = () => (
  <main>
    <HeroSection />
    <TrustStrip />
    <HowItWorks />
    <QuoteForm />
    <ServicesSection />
    <MovingSimpleSection />
    <ReviewsSection />
    <ComparisonSection />
    <SocialProofStats />
    <FinalCta />
    <Footer />
    <StickyCallButton />
  </main>
);

export default Index;
